var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92709 8.19929C1.21238 9.29258 0.89571 10.5985 1.03028 11.8978C1.16484 13.197 1.74245 14.4103 2.66606 15.3339C3.58966 16.2576 4.803 16.8352 6.10223 16.9697C7.40146 17.1043 8.70742 16.7876 9.80071 16.0729M10.6006 13.7987C12.2979 13.7987 13.9256 13.1245 15.1257 11.9244C16.3258 10.7243 17 9.09659 17 7.39937C17 5.70215 16.3258 4.07445 15.1257 2.87433C13.9256 1.67422 12.2979 1 10.6006 1C8.90342 1 7.27571 1.67422 6.0756 2.87433C4.87548 4.07445 4.20127 5.70215 4.20127 7.39937C4.20127 9.09659 4.87548 10.7243 6.0756 11.9244C7.27571 13.1245 8.90342 13.7987 10.6006 13.7987Z",
    stroke: "#E35B42",
    strokeWidth: 1.19988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0188 5.96375C11.846 5.23422 10.9661 4.57589 9.90942 5.06784C8.85272 5.56059 8.68474 7.14603 10.283 7.31402C11.0053 7.39001 11.4765 7.22603 11.9068 7.69078C12.3388 8.15553 12.4188 9.44901 11.3165 9.79777C10.2142 10.1465 9.12309 9.60179 9.00391 8.82827M10.5909 4.20312V4.89906M10.5909 9.90496V10.6025",
    stroke: "#E35B42",
    strokeWidth: 1.19988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/Currency.9720f77d4d5c56e98c2a79b8ce42e960.svg";
export { ForwardRef as ReactComponent };